import React, { useState, useRef } from "react";
import useOutside from "../../hooks/useOutSide";
import ChevronDown from "../../icon/ChevronDown";
import ChevronUp from "../../icon/ChevronUp";

const DropDown = ({ options = [], selected, setState, fontSize = "14px" }) => {
  const wrapperRef = useRef(null);
  const [isActive, setIsActive] = useState(false);
  useOutside(wrapperRef, setIsActive);

  const buttonHandler = () => {
    setIsActive(!isActive);
  };

  const itemHandler = (item) => {
    setState(item);
    setIsActive(!isActive);
  };

  return (
    <div
      className="my-0 mx-auto relative w-full"
      ref={wrapperRef}
      style={{ zIndex: isActive ? "1" : "0" }}
    >
      <button
        className="bg-white cursor-pointer px-2.5 py-2 flex items-center justify-between w-full text-sm rounded-md text-custom-gray-400"
        style={{ fontSize: fontSize }}
        onClick={buttonHandler}
      >
        {selected}
        {isActive ? <ChevronUp /> : <ChevronDown />}
      </button>
      <div
        className="absolute left-0 w-full shadow-home-card bg-white rounded-[5px]"
        style={{
          display: isActive ? "block" : "none",
        }}
      >
        {options?.map((item, index) => (
          <div
            key={index}
            className="p-[10px] text-sm cursor-pointer capitalize hover:bg-gray-100"
            onClick={() => itemHandler(item)}
            style={{ fontSize: fontSize }}
          >
            {item}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DropDown;
